import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

export function usePageViewTracking(title: string) {
  useEffect(() => {
    const tagManagerArgs = {
      dataLayer: {
        event: 'page_view',
        virtual_page_title: title,
        virtual_page_url: location.pathname,
      },
    }

    TagManager.dataLayer(tagManagerArgs)
  }, [])
}
